import React, { Dispatch, FC, SetStateAction } from 'react'
import DetailRow from './DetailRow'

interface Props {
  isEditing: boolean
  setIsEditing: Dispatch<SetStateAction<boolean>>
  label: string
  value?: string
}

const Wrapper: FC = ({ children }) => <div className="mt-4">{children}</div>

const EditableDetailRow: FC<Props> = ({ isEditing, setIsEditing, label, value = '-', children }) => {
  if (isEditing) {
    return <Wrapper>{children}</Wrapper>
  }

  return (
    <Wrapper>
      <DetailRow label={label} value={value}>
        <div>
          <button
            type="button"
            className="text-secondary bg-light-blue p-1 btn btn-link"
            onClick={() => setIsEditing(true)}
          >
            <span className="icon-pencil"></span>
          </button>
        </div>
      </DetailRow>
    </Wrapper>
  )
}

export default EditableDetailRow
